<script setup lang="ts">
import type { ButtonProps } from '.';

import { cn } from '@/utils';
import { Primitive } from 'reka-ui';

import { buttonVariants } from '.';
import { Skeleton } from '../skeleton';

const props = withDefaults(defineProps<ButtonProps>(), {
	as: 'button',
	disabled: false,
	isClientOnly: true
});
</script>

<template>
	<ClientOnly v-if="props.isClientOnly">
		<template #fallback>
			<Primitive
				v-bind="$attrs"
				:as="as"
				:as-child="asChild"
				:class="cn(buttonVariants({ variant, size }), props.class)"
				:disabled="disabled"
			>
				<slot></slot>
			</Primitive>
		</template>

		<Skeleton
			:is-active="props.isSkeletonLoading"
			:variant="props.skeletonVariant"
			:class="props.skeletonClasses"
		>
			<Primitive
				v-bind="$attrs"
				:as="as"
				:as-child="asChild"
				:class="cn(buttonVariants({ variant, size }), props.class)"
				:disabled="disabled"
			>
				<slot></slot>
			</Primitive>
		</Skeleton>
	</ClientOnly>
	<template v-else>
		<Skeleton
			:is-active="props.isSkeletonLoading"
			:variant="props.skeletonVariant"
			:class="props.skeletonClasses"
		>
			<Primitive
				v-bind="$attrs"
				:as="as"
				:as-child="asChild"
				:class="cn(buttonVariants({ variant, size }), props.class)"
				:disabled="disabled"
			>
				<slot></slot>
			</Primitive>
		</Skeleton>
	</template>
</template>
